export class ColorUtils {
  static darken(color: string) {
    switch (color) {
      case '#E4F3FF':
        return '#398AC8';
      case '#E1FCD5':
        return '#6AB849';
      case '#99AAB7':
        return '#52606B';
      case '#FA9898':
        return '#EB4444';
      case '#FFEBD4':
        return '#F29323';
      default:
        return color;
    }
  }
}
